import { useCallback, useMemo } from 'react';

import { ScopeModel } from '../../../modules/Apps';
import { useUpdateScope } from '../../../modules/Apps/Scopes';
import { getApiErrorMessage } from '../../../utils/Api';
import { PopoverStateReturn } from '../../common/Drawer/Drawer.context';
import { FormDrawer } from '../../common/FormDrawer';
import { useToasterContext } from '../../common/Toaster';

import {
  createScopesFormValidationSchema,
  ScopesForm,
  ScopesFormValues,
  ScopesFormValuesToDto,
} from './ScopesForm';

interface EditScopesDrawerProps {
  state: PopoverStateReturn;
  scope: ScopeModel;
}

export function EditScopesDrawer({ state, scope }: EditScopesDrawerProps) {
  const { mutateAsync } = useUpdateScope();
  const { showSuccess, showError } = useToasterContext();

  const handleSubmit = useCallback(
    async (values: ScopesFormValues) => {
      await mutateAsync(ScopesFormValuesToDto(values), {
        onSuccess: () => showSuccess('Scope successfully updated.'),
        onError: error =>
          showError(
            getApiErrorMessage(
              error,
              'There was an error updating the Scope. Please, try again later.',
            ),
          ),
      });
    },
    [mutateAsync, showError, showSuccess],
  );

  const initialValues: ScopesFormValues = useMemo(
    () => ({
      ...scope,
    }),
    [scope],
  );

  const validationSchema = useMemo(() => createScopesFormValidationSchema(), []);

  return (
    <FormDrawer
      state={state}
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      title="Edit Scope"
      subtitle="Edit this scope for the application"
      validationSchema={validationSchema}
      validateOnBlur={false}
    >
      {() => <ScopesForm isEditing />}
    </FormDrawer>
  );
}
